import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import DecklistPreview from "./DecklistPreview";
import DecklistPreviewDraft from "./DecklistPreviewDraft";

//HOOKS
import useDecklistHandler from "../../hooks/useDecklistInteractiveHandler";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

export default function DecklistViewer() {
   const [
      liveData,
      decklist,
      decklistCards,
      sideboardCards,
      allDecklists,
      { subscribeDecklistViewer, getDecklist, getAllDecklists },
   ] = useDecklistHandler();

   useEffect(() => {
      subscribeDecklistViewer();
   }, []);

   useEffect(() => {
      // getDecklist(decklist);
   }, [decklist]);

   useEffect(() => {
      // console.log(liveData);
   }, [liveData]);

   return (
      <>
         {liveData && (
            <>
               {liveData.layout != "Draft" && (
                  <DecklistPreview
                     preview={false}
                     iframeScale={1}
                     decklistId={liveData.decklistId}
                     sideboardVisible={liveData.sideboardVisible}
                     zoomCard={liveData.zoomCard}
                     zoomSideboardCard={liveData.zoomSideboardCard}
                     zoomCardPos={liveData.zoomCardPos}
                     cardRotation={liveData.cardRotation}
                  />
               )}
               {liveData.layout == "Draft" && (
                  <DecklistPreviewDraft
                     preview={false}
                     iframeScale={1}
                     decklistId={liveData.decklistId}
                     sideboardVisible={liveData.sideboardVisible}
                     zoomCard={liveData.zoomCard}
                     zoomSideboardCard={liveData.zoomSideboardCard}
                     zoomCardPos={liveData.zoomCardPos}
                     cardRotation={liveData.cardRotation}
                  />
               )}
            </>
         )}
      </>
   );
}
